import React, { use } from 'react';

import { SiteContext } from '../../context/site-context';
import useSiteLogos from '../../custom-hooks/use-site-logos';
import FixedImage from '../common/fixed-image';
import LanguagePicker from '../common/language-picker';
import { WebsiteLink } from '../common/website-link';
import CloseIcon from '../icons/close';

import * as styles from './simple-nav-bar-with-spacer.module.scss';

type SimpleNavBarProps = {
  onCloseButtonClicked: () => void;
  logoWrapper?: React.ReactElement;
};

const SimpleNavBarWithSpacer: React.FC<SimpleNavBarProps> = ({
  onCloseButtonClicked,
  logoWrapper = <WebsiteLink to="/" />,
}) => {
  const { styling } = use(SiteContext);
  const logos = useSiteLogos();
  return (
    <>
      <div id="wizard-nav" className={styles.nav}>
        <div className={styles.logo}>
          {React.cloneElement(
            logoWrapper,
            undefined,
            <FixedImage imageDetails={logos.headerLogo} />
          )}
        </div>
        <div className={styles.spacer} />
        <LanguagePicker />
        <div className={styles.closeButton} onClick={onCloseButtonClicked}>
          <CloseIcon size="2rem" fill={styling.colors.highlightText} />
        </div>
      </div>
      <div className={styles.bottomSpacer} />
    </>
  );
};

export default SimpleNavBarWithSpacer;
